import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { inject, Service } from '@angular/core';
import { MngLoadingComponent } from './mng-loading.component';

@Service()
export class MngLoadingService {
  private readonly overlay = inject(Overlay);

  private overlayRef: OverlayRef;

  private timeout;

  private readonly loadingComponentPortal = new ComponentPortal(MngLoadingComponent);

  private activatedOverlaysCount = 0;

  showOverlay(delay = 250) {
    if (!this.overlayRef) {
      const overlayConfig: OverlayConfig = { width: '100%', height: '100%', panelClass: 'loading-spinner-overlay' };
      this.overlayRef = this.overlay.create(overlayConfig);
    }
    this.activatedOverlaysCount++;
    this.clearTimeout();
    this.timeout = setTimeout(() => {
      if (!this.overlayRef.hasAttached()) {
        this.overlayRef.attach(this.loadingComponentPortal);
      }
    }, delay);
  }

  removeOverlay() {
    if (this.activatedOverlaysCount > 0) {
      this.activatedOverlaysCount--;
    }
    if (!this.activatedOverlaysCount) {
      this.clearTimeout();
      this.detach();
    }
  }

  private clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  private detach() {
    if (!this.overlayRef || !this.overlayRef.hasAttached()) {
      return;
    }
    const overlayElement = this.overlayRef.overlayElement;

    if (overlayElement) {
      // trigger fade-out & unblur
      overlayElement.classList.add('loading-spinner-overlay-exit');

      // wait for animation to complete before removing from DOM
      setTimeout(() => {
        this.overlayRef.detach();
        overlayElement.classList.remove('loading-spinner-overlay-exit');
      }, 200);
    } else {
      this.overlayRef.detach();
    }
  }
}
